export const findTeam = (object, key) => {
  //console.log("IN FIND TEAM " + JSON.stringify(object))
  var value;
  Object.keys(object).some(function (k) {
    if (k === key) {
      value = object[k];
      return true;
    }
    return false;
  });
  return value;
};

export const getUsersCards = async (username) => {
  try {
    // TODO: Replace with your new AWS API Gateway URL
    const API_GATEWAY_URL =
      "https://ztzb4a26ej.execute-api.eu-west-2.amazonaws.com/Prod";

    const [ownedCardsResponse, wantedCardsResponse] = await Promise.all([
      fetch(
        `${API_GATEWAY_URL}/getOwnedCards?userName=${username || "jinky32"}`
      ),
      fetch(
        `${API_GATEWAY_URL}/getWantedCards?userName=${username || "jinky32"}`
      ),
    ]);
    const ownedCards = await ownedCardsResponse.json();
    const wantedCards = await wantedCardsResponse.json();
    // //console.log(ownedCards, 'ownedCards');
    // //console.log(wantedCards, 'wantedCards');
    return {
      ownedCards: ownedCards,
      wantedCards: wantedCards,
    };
    //   setExample((prevcontext => {
    //     return {
    //       ...prevcontext,
    //       age: 51,
    //       dataLoaded: true,
    //       ownedCards: ownedCards,
    //       wantedCards: wantedCards,
    //       //     nonAuthenticatedUsersWantedCards: [],
    //       // nonAuthenticatedUsersOwnedCards: []
    //     }
    //   }))
  } catch (err) {
    throw err;
  }
};
